import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

function Pagination({ rowsPerPage = 1, rowCount, onChangePage, currentPage }) {
  const totalPages = Math.max(1, Math.ceil(rowCount / rowsPerPage));
  const safePage = Math.min(Math.max(1, currentPage || 1), totalPages);

  const goTo = (p) => {
    const next = Math.min(Math.max(1, p), totalPages);
    if (next !== safePage) onChangePage?.(next);
  };

  return (
    <nav className="flex items-center justify-between border-t border-zinc-200 bg-zinc-50 px-4 py-3 dark:border-zinc-700 dark:bg-zinc-900">
      <div className="text-sm text-zinc-600 dark:text-zinc-300">
        Page <span className="font-semibold text-zinc-900 dark:text-zinc-100">{safePage}</span> of{' '}
        <span className="font-semibold text-zinc-900 dark:text-zinc-100">{totalPages}</span>
      </div>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => goTo(safePage - 1)}
          disabled={safePage <= 1}
          className="inline-flex items-center justify-center rounded-md p-1.5 text-zinc-500 ring-1 ring-inset ring-zinc-300 hover:bg-zinc-100 disabled:cursor-not-allowed disabled:opacity-40 dark:text-zinc-400 dark:ring-white/10 dark:hover:bg-zinc-800"
        >
          <ChevronLeftIcon className="size-4" />
        </button>
        <button
          type="button"
          onClick={() => goTo(safePage + 1)}
          disabled={safePage >= totalPages}
          className="inline-flex items-center justify-center rounded-md p-1.5 text-zinc-500 ring-1 ring-inset ring-zinc-300 hover:bg-zinc-100 disabled:cursor-not-allowed disabled:opacity-40 dark:text-zinc-400 dark:ring-white/10 dark:hover:bg-zinc-800"
        >
          <ChevronRightIcon className="size-4" />
        </button>
      </div>
    </nav>
  );
}

export default Pagination;
